import { Card, CardHeader, Grid, CardMedia, styled } from "@mui/material";
import React from "react";
import { getImageFolder } from "../Utils/utils";

const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  "& .MuiCardHeader-content": {
    display: "flex",
    justifyContent: "space-between",
  },
  "& .MuiCardHeader-title": {
    fontSize: "14px",
    fontWeight: "bold",
  },
  "& .MuiCardHeader-subheader": {
    fontSize: "14px",
  },
}));

export const UpSellItem = (props) => {
  const { name, price, imageUrl, onOpen } = props;
  return (
    <Grid item xs={6} sm={4} sx={{ textAlign: "-webkit-center" }}>
      <Card
        onClick={onOpen}
        sx={{
          maxHeight: "241.11px",
          maxWidth: "208.69px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            height: "190px",
            width: "110px",
            margin: "auto",
            marginBottom: "0px",
          }}
        >
          <CardMedia
            component="img"
            image={`${getImageFolder()}/images/md_${imageUrl}`}
            alt={name}
            style={{
              maxWidth: "488px",
              maxHeight: "288px",
              width: "auto",
              height: "auto",
            }}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = `${getImageFolder()}/images/no-image-icon-6.png`;
            }}
          />
        </div>
        <StyledCardHeader
          title={name}
          subheader={price.toFixed(2) > 0 ? `$${price.toFixed(2)}` : ""}
          sx={{
            paddingLeft: "5px",
            paddingTop: "0px",
            paddingRight: "5px",
            paddingBottom: "0px",
            height: "40px",
            alignItems: "flex-start",
          }}
        />
      </Card>
    </Grid>
  );
};
